<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1"><a href="#/Publisher">Publisher’s Note</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/6chap1#chap1"><i>Remember?</i></a></p>
<p class="toc1"><a href="#/7chap2#chap2"><i>These Mornings of Rain</i></a></p>
<p class="toc1"><a href="#/8chap3#chap3"><i>First, They Said</i></a></p>
<p class="toc1"><a href="#/9chap4#chap4"><i>Listen</i></a></p>
<p class="toc1"><a href="#/10chap5#chap5"><i>S M</i></a></p>
<p class="toc1"><a href="#/11chap6#chap6"><i>The Diamonds on Liz’s Bosom</i></a></p>
<p class="toc1"><a href="#/12chap7#chap7"><i>We Alone</i></a></p>
<p class="toc1"><a href="#/13chap8#chap8"><i>Attentiveness</i></a></p>
<p class="toc1"><a href="#/14chap9#chap9"><i>1971</i></a></p>
<p class="toc1"><a href="#/15chap10#chap10"><i>Every Morning</i></a></p>
<p class="toc1"><a href="#/16chap11#chap11"><i>How Poems Are Made / A Discredited View</i></a></p>
<p class="toc1"><a href="#/17chap12#chap12"><i>Mississippi Winter I</i></a></p>
<p class="toc1"><a href="#/18chap13#chap13"><i>Mississippi Winter II</i></a></p>
<p class="toc1"><a href="#/19chap14#chap14"><i>Mississippi Winter III</i></a></p>
<p class="toc1"><a href="#/20chap15#chap15"><i>Mississippi Winter IV</i></a></p>
<p class="toc1"><a href="#/21chap16#chap16"><i>love is not concerned</i></a></p>
<p class="toc1"><a href="#/22chap17#chap17"><i>She said:</i></a></p>
<p class="toc1"><a href="#/23chap18#chap18"><i>Walker</i></a></p>
<p class="toc1"><a href="#/24chap19#chap19"><i>Killers</i></a></p>
<p class="toc1"><a href="#/25chap20#chap20"><i>Songless</i></a></p>
<p class="toc1"><a href="#/26chap21#chap21"><i>A Few Sirens</i></a></p>
<p class="toc1"><a href="#/27chap22#chap22"><i>Poem at Thirty-nine</i></a></p>
<p class="toc1"><a href="#/28chap23#chap23"><i>I Said to Poetry</i></a></p>
<p class="toc1"><a href="#/29chap24#chap24"><i>Gray</i></a></p>
<p class="toc1"><a href="#/30chap25#chap25"><i>Overnights</i></a></p>
<p class="toc1"><a href="#/31chap26#chap26"><i>My Daughter Is Coming!</i></a></p>
<p class="toc1"><a href="#/32chap27#chap27"><i>When Golda Meir Was in Africa</i></a></p>
<p class="toc1"><a href="#/33chap28#chap28"><i>If “Those People” Like You</i></a></p>
<p class="toc1"><a href="#/34chap29#chap29"><i>On Sight</i></a></p>
<p class="toc1"><a href="#/35chap30#chap30"><i>I’m Really Very Fond</i></a></p>
<p class="toc1"><a href="#/36chap31#chap31"><i>Representing the Universe</i></a></p>
<p class="toc1"><a href="#/38chap32#chap32"><i>Family Of</i></a></p>
<p class="toc1"><a href="#/39chap33#chap33"><i>Each One, Pull One</i></a></p>
<p class="toc1"><a href="#/40chap34#chap34"><i>Who?</i></a></p>
<p class="toc1"><a href="#/41chap35#chap35"><i>Without Commercials</i></a></p>
<p class="toc1"><a href="#/42chap36#chap36"><i>No One Can Watch the Wasichu</i></a></p>
<p class="toc1"><a href="#/43chap37#chap37"><i>The Thing Itself</i></a></p>
<p class="toc1"><a href="#/44chap38#chap38"><i>Torture</i></a></p>
<p class="toc1"><a href="#/45chap39#chap39"><i>Well.</i></a></p>
<p class="toc1"><a href="#/46chap40#chap40"><i>Song</i></a></p>
<p class="toc1"><a href="#/47chap41#chap41"><i>These Days</i></a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/48biography#biography">A Biography of Alice Walker</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-TOC.vue?75336d35